import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';

import { API_preferences_user, API_preferences_users_workspaces } from '@core/api/paths';
import { TGuid } from '@core/helpers';
import { map, Observable } from 'rxjs';
import {
  TPreferences,
  TUpdateExportPreference,
  TWorkspacePreferences,
} from 'src/app/project/modules/preferences/preferences.model';
import { PreferencesViewModelFactory } from './preferences-view-model-factory';

@Injectable({
  providedIn: 'root',
})
export class PreferencesApiProviderService {
  constructor(private apiService: ApiService) {}

  getUserPreferences(userId: TGuid): Observable<TPreferences> {
    const url = API_preferences_user(userId);

    return this.apiService
      .get<TPreferences>(url)
      .pipe(map((dto) => PreferencesViewModelFactory.createFromDTO(dto)));
  }

  updateUserPreferences(id: TGuid, preferences: Partial<TPreferences>): Observable<TPreferences> {
    const url = API_preferences_user(id);

    return this.apiService
      .post<TPreferences>(url, preferences)
      .pipe(map((dto) => PreferencesViewModelFactory.createFromDTO(dto)));
  }

  getExportPreferences(workspaceId: string): Observable<TWorkspacePreferences> {
    const url = API_preferences_users_workspaces(workspaceId);

    return this.apiService.get<TPreferences>(url);
  }

  updateExportPreferences(
    workspaceId: string,
    newPreferences: TWorkspacePreferences,
  ): Observable<TPreferences> {
    const url = API_preferences_users_workspaces(workspaceId);

    const body: TUpdateExportPreference = {
      exports: newPreferences.exports,
    };

    return this.apiService.post<TPreferences>(url, body);
  }
}
